export const links = [
    {
        "nombre" : "Transparencia",
        "link" : "/Transparencia",
        "submenu" : [
            {
                "subMenuNombre" : "48 Rubros",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
            {
                "subMenuNombre" : "Rubros Anteriores",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            }
            ,
            {
                "subMenuNombre" : "Organización y Rediseño Institucional",
                "subMenuUrl" : "/Transparencia/OyRI"
            }
            ,
            {
                "subMenuNombre" : "Programa Anual de Adquisiciones, Arrendamientos y Servicios",
                "subMenuUrl" : "/Transparencia/PAAAS"
            }
           ,  {
                "subMenuNombre" : "Programa Anual de Desarrollo Archivístico",
                "subMenuUrl" : "/Transparencia/PADA"
            } 
        ]
    },
    {
        "nombre" : "eoficialia",
        "link" : "https://eoficialia.hidalgo.gob.mx/SIAUUOM/",
        "submenu" : [
            {
                "subMenuNombre" : "Portal eoficialia",
                "subMenuUrl" : "https://eoficialia.hidalgo.gob.mx/SIAUUOM/"
            },
           
           
        ]
    }, 
    {
        "nombre" : "Tablero Notificador",
        "link" : "https://siom.hidalgo.gob.mx/SIPAIN/Vistas/BienesInmuebles/TableroNotificador.aspx",
        "submenu" : [
                {
                    "subMenuNombre" : "Tablero Notificador",
                    "subMenuUrl" : "https://siom.hidalgo.gob.mx/SIPAIN/Vistas/BienesInmuebles/TableroNotificador.aspx"
                },
        ]
    }, 
    {
        "nombre" : "Trámites y Servicios",
        "link" : "/Tramites",
        "submenu" : [
            {
                "subMenuNombre" : "Licitaciones Públicas",
                "subMenuUrl" : "/Licitaciones"
            },
           
            {
                "subMenuNombre" : "Publicación de las bases para la enajenación de bienes muebles",
                "subMenuUrl" : "/Enajenacion"
            },
            {
                "subMenuNombre" : "Vinculación al Servicio Social y las Prácticas Profesionales",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/1690"
            },
            {
                "subMenuNombre" : "Visita al Museo de documentos históricos",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/1691"
            },
            {
                "subMenuNombre" : "Prestámo de documentos históricos",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/1693"
            },
            {
                "subMenuNombre" : "Certificación de copias de documentos históricos",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/7663"
            },
            {
                "subMenuNombre" : "Pago de Arrendamiento",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/1694"
            },
            {
                "subMenuNombre" : "CONVOCATORIA PÚBLICA No. OM-PCH-001-2025",
                "subMenuUrl" : "/pdf/nuevo-tramite.pdf"

            },
          
        ]



    }
    ,
    {
        "nombre" : "Programas Alternativos",
        "link" : "/Programas",
        "submenu" : [
            {
                "subMenuNombre" : "Protocolo Cero",
                "subMenuUrl" : "/ProtocoloCero"
            },
            {
                "subMenuNombre" : "Comité de Ética y Prevención de Conflictos de Interes",
                "subMenuUrl" : "/CEPCI"
            },
            
            {
                "subMenuNombre" : "Programa Operativo Anual",
                "subMenuUrl" : "/POA"
            }, 
            {
                "subMenuNombre" : "Convenios para Trabajadores del Estado",
                "subMenuUrl" : "/Convenios"
            },
                      
            {
                "subMenuNombre" : "Exposiciones vigentes en Museo",
                "subMenuUrl" : "/Museo"
            },
            {
                "subMenuNombre" : "El Escribano",
                "subMenuUrl" : "/Escribano"
            },
            {
                "subMenuNombre" : "Criterios para el procedimiento de contratación",
                "subMenuUrl" : "/Adquisiciones"
            },
            {
                "subMenuNombre" : "Consultorios Médicos",
                "subMenuUrl" : "/Consultorios"
            },
            {
                "subMenuNombre" : "Programa Especial de Desarrollo ",
                "subMenuUrl" : "/Programas"
            },
        ]
    },
    

  
{
    "nombre" : "Directorio",
    "link" : "/Directorio",
     "submenu" : [
        {
            "subMenuNombre" : "Directorio",
            "subMenuUrl" : "/Directorio"
        },
     
       
    ] 
}

    
]   